export default {"src":"/_next/static/media/arrow-icon.4afdb1fc.svg","height":10,"width":23};